import React from 'react'
import { cn } from 'components/UI/cn'
import {
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from 'components/UI/BaseDropdown/dropdown-base'
import {
  ds2026DropdownContentClass,
  ds2026DropdownItemClass,
  ds2026DropdownItemDestructiveClass,
  ds2026DropdownSeparatorClass,
} from 'components/FbUI/ds2026DropdownMenu'
import { EmailAction } from './types'

interface EmailActionMenuItemsProps {
  actions: EmailAction[]
}

/**
 * Renders a list of EmailAction items inside a DropdownMenuContent.
 * Handles regular items, disabled items, destructive items (red treatment),
 * and submenu items (e.g. "Assign to deal").
 */
export function EmailActionMenuItems({ actions }: EmailActionMenuItemsProps) {
  return (
    <>
      {actions.map((action, index) => {
        const isDestructive = action.variant === 'destructive'
        const previousIsDestructive =
          index > 0 && actions[index - 1]?.variant === 'destructive'
        // Auto-insert a divider before the first destructive item so it sits in
        // its own section — matches ActionsDropdown so every menu reads the same.
        const needsSeparatorBefore =
          isDestructive && index > 0 && !previousIsDestructive
        return (
          <React.Fragment key={index}>
            {needsSeparatorBefore && (
              <DropdownMenuSeparator className={ds2026DropdownSeparatorClass} />
            )}
            {action.subContent && !action.disabled ? (
              <DropdownMenuSub>
                <DropdownMenuSubTrigger className={ds2026DropdownItemClass}>
                  <action.icon className="size-[18px] flex-shrink-0 text-current" />
                  <span>{action.label}</span>
                </DropdownMenuSubTrigger>
                <DropdownMenuSubContent
                  className={cn('p-0', ds2026DropdownContentClass)}
                >
                  {action.subContent}
                </DropdownMenuSubContent>
              </DropdownMenuSub>
            ) : (
              <DropdownMenuItem
                disabled={action.disabled}
                onSelect={action.disabled ? undefined : action.onClick}
                className={cn(
                  isDestructive
                    ? ds2026DropdownItemDestructiveClass
                    : ds2026DropdownItemClass,
                  action.disabled && '!opacity-50 !cursor-not-allowed'
                )}
              >
                <action.icon className="size-[18px] flex-shrink-0 text-current" />
                <span>{action.label}</span>
              </DropdownMenuItem>
            )}
            {action.hasSeparatorAfter && (
              <DropdownMenuSeparator className={ds2026DropdownSeparatorClass} />
            )}
          </React.Fragment>
        )
      })}
    </>
  )
}
